export enum Constants {
    KurzoveSazky = "kurzovesazky",
    NotApplied = "not_applied",
    NoGame = "no_game",
    NoAdditionalWinnings = "no_additional_winnings",
}
